export default "__VITE_ASSET__BT4oZSqk__"